'use client';

import type { ReactNode, ReactElement } from 'react';
import { networks, projectId, wagmiAdapter } from '@/lib/constants/config';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { WagmiProvider } from 'wagmi';
import { createAppKit } from '@reown/appkit/react';

const queryClient = new QueryClient();

const metadata = {
  name: 'KILOWATTCOIN',
  description: 'The economy secured by generating energy.',
  url: 'https://kilowattcoin.ru',
  icons: ['https://avatars.githubusercontent.com/u/319426359'],
};

createAppKit({
  projectId,
  metadata,
  features: { smartSessions: false, socials: false, email: false, history: false, onramp: false },
  adapters: [wagmiAdapter],
  networks: networks,
  defaultNetwork: networks[0],
  defaultAccountTypes: { eip155: 'eoa' },
});

export default function BlockchainProvider({
  children,
}: {
  readonly children: ReactNode;
}): ReactElement {
  return (
    <WagmiProvider config={wagmiAdapter.wagmiConfig}>
      <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>
    </WagmiProvider>
  );
}
